import React from 'react';
import { useTranslation } from 'react-i18next';

import SectionTitle from '../../components/SectionTitle/SectionTitle';

import priorityImg from '../../assets/about/priority.webp';

import './OurValues.scss';

const Priority = () => {
    const { t } = useTranslation();

    return (
        <section
            className="priority-section"
            data-aos="fade-up"
            data-aos-duration="2000"
        >
            <div className="container-fluid">

                <div className="row align-items-center">

                    <div className="col-lg-6 col-md-6">
                        <div className="priority-img">
                            <img
                                src={priorityImg}
                                alt={t('priority.imageAlt')}
                            />
                        </div>
                    </div>

                    <div className="col-lg-6 col-md-6">

                        <div className="priority-text">

                            <SectionTitle
                                subTitle={t('priority.subTitle')}
                                title={t('priority.title')}
                                description={t('priority.description')}
                            />

                            <div className="theme-btn">

                                <a
                                    href="https://dr-flex.de/embed?medicalPracticeId=53366"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {t('priority.appointment')}
                                </a>

                            </div>

                        </div>

                    </div>

                </div>

            </div>
        </section>
    );
};

export default Priority;